import { IconGeoObjectMarkers, IconGeoObjSeismic3D, IconPolygonMultiple } from '@core/icons'

import type { Item } from './types'

export const items: Item[] = [
  {
    icon: IconGeoObjectMarkers,
    title: 'Маркеры',
    description: 'ascii',
    mode: 'markers',
    disabled: false,
  },
  {
    icon: IconGeoObjSeismic3D,
    title: '3D съемки',
    description: 'sgy, segy',
    mode: 'survey3D',
    disabled: false,
  },
  {
    icon: IconPolygonMultiple,
    title: 'Массовый импорт',
    description: 'las',
    mode: 'bulk',
    disabled: false,
  },
]
